import type { Messages } from './en';

/** Textos de la búsqueda del tesoro. Los acertijos siguen en inglés (ver content/treasure.ts). */
export const esTreasure: Pick<Messages, 'treasure'> = {
  treasure: {
    title: '🏴‍☠️ Búsqueda del tesoro',
    intro: 'Hoy hay tres tesoros escondidos. Lee las pistas en inglés, sigue la brújula y cava cuando diga “¡Justo aquí, cava!”.',
    clue: (n: number) => `Pista ${n}`,
    listen: '🔊 Escuchar',
    translate: '🌐 Ayuda en mi idioma',
    follow: '🧭 Seguir esta pista',
    following: '🧭 Siguiendo',
    done: '✅ ¡Encontrado!',
    heat: ['🧊 Frío', '🌤️ Templado', '☀️ Caliente', '🔥 ¡Te quemas!', '⛏️ ¡Justo aquí, cava!'],
    otherMap: '🧭 Aquí no está: prueba en otro sitio',
    dig: '⛏️ Cavar aquí',
    found: '¡Has encontrado un cofre del tesoro!',
    foundItem: (icon: string, name: string) => `¡Tesoro! Has encontrado: ${icon} ${name}`,
    allFound: '🏆 ¡Has encontrado todos los tesoros de hoy! Premio +10⭐ +30🪙',
    albumTitle: 'Álbum de tesoros',
    album: {
      coin: 'Moneda antigua', marble: 'Canica de cristal', shell: 'Caracola en espiral', robot: 'Robot de hojalata', postcard: 'Postal antigua', charm: 'Amuleto de la suerte',
      compass: 'Brújula de latón', feather: 'Pluma dorada', stamp: 'Sello raro', crystal: 'Cristal azul', whistle: 'Silbato de plata', medal: 'Medalla de héroe',
    },
    hints: {
      fountain: 'Cerca de la fuente (del pueblo o del centro comercial).',
      pond: 'En la orilla del estanque del parque.',
      cherry: 'Debajo de un cerezo en el patio del colegio.',
      busStop: 'Al lado de la parada del autobús de la calle principal.',
      slide: 'Junto al tobogán del parque infantil.',
      hay: 'Al lado de la paja de las cuadras.',
      tennis: 'En una esquina de la pista de tenis.',
      track: 'En una esquina de la pista de atletismo.',
      mailbox: 'Junto al buzón rojo delante de tu casa.',
      kiteTree: 'Debajo del árbol grande del barrio.',
      library: 'En la biblioteca, cerca de la mesa de lectura.',
      piano: 'En el aula de música, al lado del piano.',
      easel: 'En el aula de plástica, cerca del caballete.',
      pool: 'En la piscina, cerca de la silla del socorrista.',
      store: 'Dentro de la tienda de la esquina, entre las estanterías.',
      sofa: 'En casa, cerca del sofá del salón.',
    },
  },
};
